import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { mapCurrencyRateDto, type CurrencyRate, type CurrencyRateDto } from './currency-rate.model';
import type { CurrencyRatesSource } from './currency-rates-source';

export const SCO_CURRENCIES_RATES_URL = 'http://localhost:8080/SelfCheckout/getCurrenciesRates';

interface ScoCurrenciesRatesResponse {
  result?: CurrencyRateDto[];
}

@Injectable({
  providedIn: 'root',
})
export class ScoCurrencyRatesSource implements CurrencyRatesSource {
  readonly id = 'sco' as const;

  private readonly httpClient = inject(HttpClient);

  loadRates(): Observable<CurrencyRate[]> {
    return this.httpClient
      .get<ScoCurrenciesRatesResponse>(SCO_CURRENCIES_RATES_URL)
      .pipe(
        map(response =>
          (response.result ?? [])
            .map(dto => mapCurrencyRateDto(dto))
            .filter((rate): rate is CurrencyRate => rate !== null),
        ),
      );
  }
}
